<template>
    <div class="service-order-wrapper">
        <div class="search-nav">
            <div class="select">
                <div class="start-picker picker" @click="showStartModal">
                    {{startDateFmt}}
                    <img :src="downArrowSrc" alt>
                </div>
                <div style="position:relative;top:3px;">-</div>
                <div class="end-picker picker" @click="showEndModal">
                    {{endDateFmt}}
                    <img :src="downArrowSrc" alt>
                </div>
            </div>
            <div class="search-btn" @click.stop="inqueryData">查询</div>
        </div>
        <div class="total-wra" v-if="yyq_user_type == 2">
            <div class="left">
                <div class="num">￥{{service.total}}</div>
                <div class="h">累计金额</div>
            </div>
            <div class="right">
                <div class="num">{{service.recordCount}}</div>
                <div class="h">服务次数</div>
            </div>
        </div>
        <div class="no-result" v-if="detailData.length === 0">
            <img :src="noorderSrc">
            <p>还没有相关订单哦~</p>
        </div>
        <van-pull-refresh v-model="isLoading" v-else class="refresh-wra" @refresh="pullDownRefresh">
            <img slot="loading" :src="loadingSrc" class="boms-loading-sm">
            <img slot="normal" :src="loadingSrc" class="boms-loading-sm">
            <img slot="pulling" :src="loadingSrc" class="boms-loading-sm">
            <img slot="loosing" :src="loadingSrc" class="boms-loading-sm">
            <van-list
                v-model="pullUpLoading"
                :finished="isMaxData"
                :immediate-check="false"
                @load="pullUpLoadData"
            >
                <list-of-record
                    v-for="item of detailData"
                    :key="item.id"
                    :type="yyq_user_type"
                    :item="item"
                ></list-of-record>
            </van-list>
        </van-pull-refresh>

        <van-actionsheet v-model="showSelectModal" title=" ">
            <van-datetime-picker
                v-model="currentStartDate"
                class="date-modal"
                v-show="modalType === 1"
                title="选择开始日期"
                type="date"
                @cancel="showSelectModal = false"
                @confirm="changeStartDate"
            />
            <van-datetime-picker
                v-model="currentEndDate"
                v-show="modalType === 2"
                title="选择结束日期"
                type="date"
                @cancel="showSelectModal = false"
                @confirm="changeEndDate"
            />
        </van-actionsheet>
    </div>
</template>

<script>
import ListOfRecord from "@/components/ListOfRecord";
export default {
    name: "UserYYQOrderDetail",
    components: { ListOfRecord },
    data() {
        return {
            isLoading: false,
            pullUpLoading: false,
            isMaxData: false,
            currentPage: 0,
            detailData: [],
            numberInEachPage: 10,
            startDateFmt: "",
            endDateFmt: "",
            currentStartDate: new Date(),
            currentEndDate: new Date(),
            showSelectModal: false,
            modalType: 1,
            yyq_user_type: 0,
            service: {
                total: 0,
                recordCount: 0
            },
            downArrowSrc: "",
            noorderSrc: "",
            loadingSrc: ""
        };
    },
    computed: {
        // startDateFormat() {
        //     return this.startDate.subtract(7, "days").format("YYYY-MM-DD");
        // },
        // endDateFormat() {
        //     return this.endDate.format("YYYY-MM-DD");
        // }
    },
    created() {
        this.pullDownRefresh();
        this.yyq_user_type = sessionStorage.yyq_user_type;
    },
    mounted() {
        this.downArrowSrc = API.ossUrl + "yyq/my/order_detail/down-arrow.png";
        this.noorderSrc = API.ossUrl + "yyq/empty_icons/noorder.png";
        this.loadingSrc = API.ossUrl + "yyq/loading.gif";
    },
    destroyed() {},
    methods: {
        getDataFromPage(number = 1) {
            let vm = this;
            let dateString =
                this.endDateFmt && this.startDateFmt
                    ? encodeURIComponent(
                          this.startDateFmt + "," + this.endDateFmt
                      )
                    : "all";
            return this.$axios.get(
                `${API.user.orderlist}/${dateString}/${number}/${
                    this.numberInEachPage
                }?token=${sessionStorage.token}`
            );
        },
        //下拉刷新
        pullDownRefresh() {
            let vm = this;
            this.getDataFromPage(1)
                .then(({ data }) => {
                    if (data.code == 200) {
                        let res = data.data;
                        vm.detailData = res.list;
                        vm.service = {
                            total: res.total,
                            recordCount: res.recordCount
                        };
                        vm.isLoading = false;
                        vm.currentPage = 1;
                        vm.isMaxData = res.pageNo >= res.pageCount;
                    } else {
                        vm.$toast(data.msg);
                    }
                })
                .catch(err => console.log(err));
        },
        //上拉加载
        pullUpLoadData(number) {
            let vm = this;
            if (vm.currentPage == 0) return (vm.pullUpLoading = false);
            this.getDataFromPage(vm.currentPage + 1)
                .then(({ data }) => {
                    if (data.code == 200) {
                        let res = data.data;
                        vm.detailData = vm.detailData.concat(res.list);
                        vm.pullUpLoading = false;
                        vm.currentPage = Number(res.pageNo);
                        vm.isMaxData = res.pageNo >= res.pageCount;
                    } else {
                        vm.$toast(data.msg);
                    }
                })
                .catch(err => console.log(err));
        },
        changeStartDate(v) {
            this.startDateFmt = moment(v).format("YYYY-MM-DD");
            this.showSelectModal = false;
        },
        changeEndDate(v) {
            this.endDateFmt = moment(v).format("YYYY-MM-DD");
            this.showSelectModal = false;
        },
        showStartModal() {
            this.showSelectModal = true;
            this.modalType = 1;
        },
        showEndModal() {
            this.showSelectModal = true;
            this.modalType = 2;
        },
        inqueryData() {
            if (!this.startDateFmt) {
                this.$alert("请选择开始时间！");
                return;
            }
            if (!this.endDateFmt) {
                this.$alert("请选择结束时间！");
                return;
            }
            if (new Date(this.endDateFmt) - new Date(this.startDateFmt) < 0) {
                this.$alert("开始时间不能大于结束时间！");
                return;
            }
            this.pullDownRefresh();
        }
    }
};
</script>

<style scoped lang="scss">
.service-order-wrapper {
    display: flex;
    flex-direction: column;
    min-height: 100%;
    background: #f5f5f5;
    .no-result {
        color: #666;
        font-size: 16px;
        margin-top: 42%;
        flex: 1;
        text-align: center;
        img {
            margin-bottom: 0.666667rem;
            width: 7.386667rem;
            height: 5.666667rem;
        }
        p {
            color: #444444;
            font-size: 14px;
            text-align: center;
            font-weight: bold;
        }
    }
    .van-pull-refresh {
        width: 100%;
        flex: 1;
    }
    .search-nav {
        font-size: 14px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0.32rem 0.533333rem;
        margin-bottom: 0.266667rem;
        background: $white;
        .select {
            display: flex;
        }
        .picker {
            width: 3.12rem;
            height: 0.746667rem;
            border: 1px solid rgba(235, 235, 235, 1);
            border-radius: 0.106667rem;
            margin: 0 6px;
            position: relative;
            display: flex;
            align-items: center;
            padding-left: 0.16rem;
            img {
                width: 0.586667rem;
                height: 0.586667rem;
                position: absolute;
                top: 2px;
                right: 1px;
            }
        }
        .search-btn {
            width: 1.173333rem;
            height: 0.746667rem;
            background: rgba(240, 187, 27, 1);
            border-radius: 0.106667rem;
            font-size: 14px;
            color: $white;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
    .total-wra {
        background: $white;
        color: $white;
        padding: 0.533333rem;
        display: flex;
        justify-content: space-between;
        .left {
            width: 5.493333rem;
            height: 3.306667rem;
            background: url("https://oss.tuoxingwang.com/vaporetto-assets/yyq/my/order_detail/detail-back1.png")
                center center no-repeat;
            background-size: contain;
        }
        .right {
            width: 3.306667rem;
            height: 3.306667rem;
            background: url("https://oss.tuoxingwang.com/vaporetto-assets/yyq/my/order_detail/detail-back2.png")
                center center no-repeat;
            background-size: contain;
        }
        .right,
        .left {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
        }
        .num {
            font-weight: bold;
            font-size: 28px;
            margin-bottom: 0.22rem;
        }
        .h {
            font-size: 14px;
        }
    }
    .refresh-wra {
        padding: 0 0.533333rem;
        background: $white;
    }
}
</style>

